"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 animate-pulse rounded-md bg-muted" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/AboutUs" className="text-muted-foreground transition-colors hover:text-primary">
            About Us
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/OurExpertisePage" className="text-muted-foreground transition-colors hover:text-primary">
            Our Services
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/ConnectWithUsPage" className="text-muted-foreground transition-colors hover:text-primary">
            Contact Us
          </Link>
        </li>
        <li data-index={3}>
          <Link to="/ReserveYourDemoPage" className="text-muted-foreground transition-colors hover:text-primary">
            Book a Demo
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground transition-colors hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const socialLinks = [{
  id: "twitter",
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  id: "linkedin",
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  id: "facebook",
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  id: "instagram",
  icon: Instagram,
  href: "#",
  label: "Instagram"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-background text-foreground border-t border-border/10 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/axebox_media_logo_footer.png" alt="Axebox Media" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Precision Modernism. Blending technical authority with raw energy to deliver cutting-edge, high-quality lead generation for the home improvement sector.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold tracking-tight">Quick Links</h4>
            <MenuProvider menu_id="44">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold tracking-tight">Contact Us</h4>
            <div className="space-y-4 text-sm">
              <div>
                <span className="mb-1 block text-muted-foreground">General Inquiries</span>
                <Link to="mailto:info@axeboxmedia.com" className="font-medium transition-colors hover:text-primary">
                  info@axeboxmedia.com
                </Link>
              </div>
              <div>
                <span className="mb-1 block text-muted-foreground">Sales & Lead Generation</span>
                <Link to="mailto:success@axeboxmedia.com" className="font-medium transition-colors hover:text-primary">
                  success@axeboxmedia.com
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold tracking-tight">Follow Us</h4>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <div key={social.id} data-index={i}>
                    <Link to={social.href} className="group flex size-10 items-center justify-center rounded-full bg-muted/50 transition-colors hover:bg-primary/10 hover:text-primary" aria-label={social.label}>
                      <Icon className="size-5 transition-transform group-hover:scale-110" />
                    </Link>
                  </div>;
            })}
            </div>
          </div>
        </div>

        {}
        <Separator className="my-8 bg-primary/40" />
        
        <div className="flex flex-col items-center justify-between gap-4 text-sm text-muted-foreground md:flex-row">
          <p>© {currentYear} Axebox Media. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="transition-colors hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="#" className="transition-colors hover:text-primary">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}